import React from "react";
import {
  Route,
  Routes,
} from "react-router-dom";

import PageLayout from './components/app/PageLayout';
import UnauthorizedPage from './features/error/UnauthorizedPage';

import { useDispatch } from "react-redux";
import { apiAuthSlice } from './features/authentication/apiAuthentication'
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";

function App() {
  const dispatch = useDispatch();

  const context = useMsal();

  React.useEffect(() => {
      dispatch(apiAuthSlice.actions.setMsalProgress(context.inProgress))
    }, [context]);

  function ErrorComponent({error}) {
      return <p>An Error Occurred: {error}</p>;
  }

  function LoadingComponent() {
      return <p>Authentication in progress...</p>;
  }

  return (
    <div className="App">
      <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} errorComponent={ErrorComponent} loadingComponent={LoadingComponent}>
        <Routes>
          <Route path="/unauthorized" element={ <UnauthorizedPage/> }/>
          <Route path="*" element={ <PageLayout/> }/>
        </Routes>
      </MsalAuthenticationTemplate>
    </div>
  );
}

export default App;
